<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card>
      <v-card-title class="pa-1">
        <v-col cols="12" class="pa-0 text-right">
          <v-btn icon color="primary" @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="pa-0 text-center">
          <h1>Histórico de eventos</h1>
        </v-col>
      </v-card-title>

      <v-card-text class="py-0">
        <v-row>
          <v-col cols="4" class="pl-8 pr-0">
            <b>Operadora:</b>
            <div>{{ historico.header.oper_nome }}</div>
          </v-col>
          <v-col cols="4" class="pl-8 pr-0">
            <b>Prestador:</b>
            <div>{{ historico.header.prest_nome }}</div>
          </v-col>
          <v-col cols="4" class="pl-8 pr-0">
            <!-- v-if="type"  -->
            <b>Login:</b>
            <div>{{ historico.header.WEB_LU }}</div>
          </v-col>
          <v-col cols="12" class="py-1">
            <v-data-table
              dense
              :headers="headers"
              :items="historico.list"
              hide-default-footer
            >
              <template v-slot:item="props">
                <tr>
                  <td>
                    {{ props.item.data_evento | formatDate }}
                  </td>
                  <td>
                    <span v-if="!props.item.erro">
                      {{ props.item.evento }}
                    </span>
                    <span v-else style="color: #d0021b">{{
                      props.item.evento
                    }}</span>
                  </td>
                  <td>
                    {{ props.item.mensagem }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-center py-5">
        <v-btn color="primary" height="30px" small depressed @click="close()"
          >Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      headers: [
        { text: "Data do evento", value: "date_evento", sortable: false },
        { text: "Evento", value: "evento", sortable: false },
        { text: "Mensagem", value: "mensagem", sortable: false },
      ],
    };
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  props: {
    dialog: Boolean,
    close: Function,
    historico: Object,
  },
};
</script>

<style>
</style>